<template>
  <PageLayout>
    <v-row>
      <v-col :sm="12">
        <h2 class="text-h3 navy--text text--darken-1 font-weight-bold pb-4">
          Často kladené dotazy
        </h2>
      </v-col>
    </v-row>

    <v-row>
      <v-col :sm="12" v-for="(item, index) in faqData" :key="`faq${index}`">
        <h3 class="text-h4 pb-2">{{ item.name }}</h3>
        <Accordion :items="item.items" />
      </v-col>
    </v-row>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/page/home/PageLayout"
import Accordion from "@/components/ui/widgets/Accordion"

export default {
  name: "Faq",
  components: {
    PageLayout,
    Accordion,
  },
  data() {
    return {
      faqData: [
        {
          name: "Obecné",
          items: [
            {
              title: "K čemu je vlastně adveroo?",
              text:
                "Adveroo je aplikace, která vám pomáhá s tvorbou reklam na sociálních sítích. V tuto chvíli na Facebooku a Instagramu. Celý proces se snažíme zjednodušovat a v každém kroku vám ukazovat, jak se jednotlivá nastavení projeví a co udělají. Snažíme se vést naše uživatele k větší efektivitě a tím i většímu úspěchu vašich kampaní.",
            },
            {
              title: "Co potřebuji k tomu, abych mohl/a s adveroo pracovat?",
              text:
                "Adveroo vám pomáhá s tvorbou reklam na Facebooku a Instagramu. Potřebujete proto mít založenou facebookovou stránku a profil na Instagramu. Dále potřebujete mít založený businessový účet na Facebooku, založený reklamní účet a nainstalovaný pixel na vaší webové stránce. Pokud nevíte, jak na to, na vše máme vytvořené tutorialy zde.<br>Pokud se vám do toho nechce, rádi vám vše nastavíme my. Tato služba je zpoplatněna 1000 Kč, objednat si ji můžete odesláním e-mailu na info@adveroo.cz",
            },
            {
              title:
                "Co se stane s mým účtem na Facebooku, když zruším účet u adveroo?",
              text:
                "Vůbec nic, všechno, co si v adveroo vytvoříte, vám zůstane k dispozici v business manageru.",
            },
            {
              title: "Nabízíte také marketingové služby na klíč?",
              text:
                'Ano - adveroo je sice navržené tak, aby ho mohl obsluhovat úplně každý, ale jestli se vám do marketingu nechce pouštět, rádi se vám o něj postaráme. Ozvat se nám (a zjistit více informací o spolupráci), můžete <a href="https://adveroo.cz/agency/" target="_blank" rel="noopener noreferrer">zde.',
            },
            {
              title: "Jak dlouho mohu využívat adveroo zdarma?",
              text:
                "Účet zdarma nabízíme novým klientům na vyzkoušení na 7 dnů. Věříme, že už za pár dnů vás adveroo dokáže přesvědčit, že vám ušetří spoustu času, energie a pomůže vám dělat lepší marketing.",
            },
            {
              title: "S online marketingem teprve začínám - Je adveroo pro mě?",
              text:
                "Ano!!! Adveroo vzniká jako „rukodržný“ nástroj. Tím myslíme to, že vás bude držet za ruku od začátku až do konce. Vysvětlí vám vše důležité a upozorní vás na to, co je opravdu důležité proto, aby vaše reklamy měly efekt, který chcete.",
            },
            {
              title: "Jak si můžu adveroo nainstalovat?",
              text:
                "Adveroo běží na našich serverech, takže si nic instalovat nemusíte. Stačí se přihlásit pomocí vašeho přihlašovacího jména a hesla a můžete ho začít hned využívat.",
            },
          ],
        },
        {
          name: "Marketing",
          items: [
            {
              title:
                "Potřebuji webovou stránku, abych mohl dělat reklamu na Facebooku / sociálních sítích?",
              text:
                "Ano i ne. Technicky můžete dělat reklamu bez webové stránky a můžete třeba sbírat sledující vaší facebookové stránky nebo profilu, ale s tím vám v adveroo nepomůžeme.<br>Pomáháme dělat kampaně tak, aby přinášely zisk - abyste díky nim prodávali své produkty a služby.<br>Tento typ reklam musí někam vést, ideálně tedy na vaši webovou stránku.",
            },
            {
              title: "Kolik je minimální rozpočet, který mám na reklamu mít?",
              text:
                "Odpověď záleží na mnoha faktorech: komu chcete reklamu ukazovat a jak často, jaký typ produktů nebo služeb nabízíte, kolik stojí atd. Doporučujeme začínat s malým rozpočtem, testovat reklamy třeba od 100 Kč / denně a postupně rozpočet navyšovat u kampaní, které se osvědčí.",
            },
            {
              title: "Komu mám svou reklamu zobrazovat?",
              text:
                "V marketingovém žargonu se lidem, na které cílíte, říká publika nebo obecenstva. Ideálně byste chtěli svou reklamu ukazovat pouze vaší cílové skupině, tedy ideálním zákazníkům, kteří mají zájem o vaše produkty a služby. Ale to není tak snadné, protože tyto lidi musíte Facebooku nějak popsat: <br><br><i>Cílíte na muže nebo ženy, jak jsou staří, kde bydlí, mají nějaké zájmy, které je předurčují k tomu, aby byli vašimi zákazníky? Atp.</i> <br><br>Například pokud byste nabízeli kurz o rybolovu, nabízí se, že vaši klienti se budou rekrutovat z řad uživatelů Facebooku, kteří mají zájem rybaření. Ne všichni lidé s tímto zájmem jsou vaše cílová skupina, ale dost z těchto lidí budou vaši potenciální zákazníci.<br><br>Tímto způsobem tvoříte publika pomocí cílení. <br><br> V adveroo máte ještě další možnosti, jak své zákazníky hledat a jak na ně cílit své reklamy. Přesně k tomuto účelu jsme vytvořili <b>Šablony publik</b>,  které vám automaticky sbírají potenciální zákazníky podle toho, jak daleko ve vašem <b>prodejním procesu</b> došli. <br><br>Důležitým nástrojem jsou také takzvaná podobná publika, která vychází z toho, že Facebook má o svých uživatelích spoustu informací. Pokud mám vytvořené publikum, které je pro mě zajímavé, jsou to například častí návštěvníci mého blogu nebo mám nasbíraný dostatek lidí, kteří přišli na moji prodejní stránku, mohu Facebooku říct, ať mou reklamu ukazuje uživatelům, kteří jsou podobní těm pro mě zajímavým.<br><br>Je například vhodné tvořit podobná publika vašich stávajících zákazníků a nebo z lidí, kteří si stahují váš magnet. Podobná publika si můžete tvořit v adveroo na 2 kliknutí.",
            },
            {
              title: "Jak fungují v adveroo šablony publik? K čemu jsou?",
              text:
                "Publika jsou jednou ze dvou <b>zásadních komponent</b> úspěšné kampaně. Úspěšná kampaň musí mít jasné a lákavé sdělení a zároveň se musí zobrazovat tomu, pro koho je přitažlivé. Pokud budete nabízet nejvíc nejlepší bio fair trade krmení pro psy na světě za nejnižší cenu na světě někomu, kdo nemá psa, pravděpodobně moc neuspějete. <br><br>Proto <b>do adveroo neustále přidáváme další a další šablony</b>, které pro vás vytváří okruhy potenciálních zákazníků. Naše šablony využívají data z Facebookového pixelu, který musíte mít nainstalovaný na svých stránkách. <br><br>Šablony si snadno aktivujete tím, že do nich vyplníte důležité údaje o vašem <b>prodejním procesu</b> a od té chvíle se vám už budou publika tvořit a sbírat.<br><br><b><center>!!! Důležité upozornění !!!<br><br></center></b>Tvorba publik (i pomocí šablon) funguje tak, že zadáte nějaké parametry (např. všichni návštěvníci mojí stránky s ebookem zdarma, nebo všichni návštěvníci mojí prodejní stránky, kteří si nekoupili produkt / službu) a Facebook si je začne označovat. Každého člověka, který pak přijde na vaše stránky (a je to uživatel Facebooku) Facebook přiřadí do vašeho publika. Dokud ale publikum nevytvoříte (t.j. neaktivujete si šablonu) Facebook vám návštěvníky označovat nebude.<br><br>Důležité je také, abyste věděli, že to Facebook nedělá zpětně! Pokud si aktivujete šablonu dnes, nebudete do ní mít zachycené návštěvníky stránky, kteří na ní byli kdykoliv dříve.<br><br>Proto si každou část svého prodejního procesu pečlivě zaznamenejte do adveroo pomocí našeho nástroje <b>Chytrá publika.</b>",
            },
            {
              title:
                "Co je to funnel? (Neboli cesta zákazníka nebo prodejní proces?)",
              text:
                'Funnel doslova znamená trychtýř a v marketingu se tímto pojmem naznačuje to, že ne ze všech návštěvníků vašich stránek se nakonec stanou vaši zákazníci. <br><br>Trychtýř má široký vstup a relativně úzký konec - je významně více návštěvníků než klientů. <b>Prostřednictvím funnelu se snažíme i z dalších potenciálních zákazníků vytvořit zákazníky skutečné.</b> Více podrobně si o funnelech můžete <a href="https://adveroo.cz/funnel-nejefektivnejsi-prodejni-nastroj-online/" target="_blank" rel="noopener noreferrer">přečíst na našem blogu.</a> ',
            },
          ],
        },
        {
          name: "Technické",
          items: [
            {
              title:
                "Co je Facebook business manager a jak ho vytvořit a nastavit?",
              text: "",
            },
            {
              title: "Co je to pixel a jak ho vytvořit a nastavit?",
              text: "",
            },
          ],
        },
      ],
    }
  },
}
</script>
